var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTemple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5416 0.133816C10.2026 -0.0446054 9.79744 -0.0446054 9.45844 0.133816L0.621225 4.78498C0.239189 4.98605 0 5.38223 0 5.81395V7.67442C0 8.31661 0.520599 8.83721 1.16279 8.83721H1.85919V14.8837H1.16279C0.520599 14.8837 0 15.4043 0 16.0465V18.8372C0 19.4794 0.520599 20 1.16279 20H18.8372C19.4794 20 20 19.4794 20 18.8372V16.0465C20 15.4043 19.4794 14.8837 18.8372 14.8837H18.1406V8.83721H18.8372C19.4794 8.83721 20 8.31661 20 7.67442V5.81395C20 5.38223 19.7608 4.98605 19.3788 4.78498L10.5416 0.133816ZM16.7453 8.83721H12.5592V14.8837H16.7453V8.83721ZM16.9801 7.44186L16.9778 7.44186H12.3267L12.3244 7.44186H7.67538L7.67315 7.44186H3.02198L3.01975 7.44186H1.39535V5.95436L10 1.42559L18.6047 5.95436V7.44186H16.9801ZM11.1639 8.83721V14.8837H8.83594V8.83721H11.1639ZM3.25454 14.8837V8.83721H7.44059V14.8837H3.25454ZM1.39535 18.6047V16.2791H18.6047V18.6047H1.39535Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTemple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/temple.63e3951dba829c6fc9c3f4db6cad8976.svg";